<template>
  <div>
    <NodePage v-if="node" v-bind="node" />
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'PageSlug',
})

definePageMeta({
  name: 'drupal-route',
  path: '/:slug(.*)*',
  drupalRoute: true,
})

const { entity: node } = await useDrupalRouteQuery('slug')

useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>
